import { useState } from 'react';
import PropTypes from 'prop-types';

// import StarRatingComponent from 'react-star-rating-component';
import ReactStars from 'react-rating-stars-component';
import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import classes from './UsersReviews.module.css';

const UsersReviews = props => {
  const [reviews, setReviews] = useState(5);

  const loadReviewsHandler = () => {
    setReviews(reviews + 5);
  };

  return (
    <>
      {props.reviewsList.map(
        (userReview, index) =>
          index < reviews && (
            <div
              key={userReview.userName}
              className={classes.reviewContainer}
            >
              <div className={classes.topReview}>
                <figure className={classes.userReviewAvatar}>
                  <img
                    style={{ borderRadius: '50%' }}
                    className={classes.img}
                    src={userReview.userImage}
                    alt={userReview.userName}
                  />
                </figure>
                <aside className={classes.textContainer}>
                  <p className={classes.userName}>
                    {userReview.userName}
                  </p>
                  <p className={classes.dateText}>
                    {userReview.pastTime}
                  </p>
                </aside>
                <aside className={classes.userReviewStars}>
                  <ReactStars
                    edit={false}
                    count={5}
                    isHalf={true}
                    size={16}
                    activeColor="#e6a817"
                    emptyStarColor="#d6d6d6"
                    value={userReview.rated ? userReview.rated : 2}
                  />
                </aside>
              </div>
              <div>
                <ThumbUpIcon className={classes.userReviewIcon} />
                <p className={classes.reviewText}>
                  {userReview.review}
                </p>
              </div>
            </div>
          )
      )}
      {reviews < props.reviewsList.length && (
        <Button
          onClick={loadReviewsHandler}
          className={classes.showMoreReviews}
        >
          Ver más valoraciones
        </Button>
      )}
    </>
  );
};

UsersReviews.propTypes = {
  // eslint-disable-next-line react/require-default-props
  reviewsList: PropTypes.array
};

export default UsersReviews;
